module.exports = "https://web-assets-production.autolist.com/_next/static/images/oem-logos-sprite-5811548e5c3a6aef20ae26f1a9384ad5.png";